import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./ConcentratorSelected.module.css";
import Column from "../assets/colums/columns.jsx";
import {
  createRow,
  createEditRow,
  sortArrayFirstOwners,
  formatResultUsers,
} from "../../../../helpers/tableFunctions";
import { Modal } from "../../../Shared/Modal/Modal.jsx";
import {
  organizationAgenciesUpdateAfterEdit,
  setConcentratorSelectedRedux,
} from "../../../../store/slices/gammaSlice.js";
import Swal from "sweetalert2";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Table,
  IconButton,
  TableCell,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Loader from "../../../Shared/Loader";
import HandleRequests from "../../../Shared/handleRequests/HandleRequests";

import { getAgencieById } from "../../../../api/agencies/AgenciesService";
import { useTranslation } from "react-i18next";
import {
  setPointCriteria,
  setPointItem,
} from "../../../../store/slices/paginationSlice";

const ConcentratorSelected = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [concentratorSelected, setConcentratorSelected] = useState(null);
  const [primaryColor, setPrimaryColor] = useState("");
  const [ligthPrimaryColor, setLightPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [editData, setEditData] = useState({
    street: "",
    zipcode: "",
    number: "",
    phone: "",
  });
  const [conditionalEditData, setConditionalEditData] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [userToAdd, setUserToAdd] = useState(null);
  const [rol, setRol] = useState("");
  const indexOfAgencie = 0;
  const [activeOrganization, setActiveOrganization] = useState(null);
  const Columns = Column();
  const backError = useSelector(
    (state) => state.errors.concentratorSelectedError,
  );
  const allConcentrators = useSelector(
    (state) => state.gamma?.organizationAgencies?.content,
  );
  const { textColor } = useSelector((state) => state.local);
  const colors = useSelector((state) => state.local.uiConfig);
  const orgSelected = useSelector((state) => state.gamma.activeOrganization);
  const dispatch = useDispatch();
  const [sort, setSort] = useState({
    item: "name",
    criteria: "ASC",
  });
  const [childrenAgencies, setChildrenAgencies] = useState([]);
  const [sortedChildrens, setSortedChildrens] = useState([]);

  const handleChangeSort = (e) => {
    setSort((prev) => ({
      ...prev,
      item: e,
      criteria: prev.criteria === "ASC" ? "DESC" : "ASC",
    }));
  };

  useEffect(() => {
    setPrimaryColor(colors?.primary?.main);
    setLightPrimaryColor(colors?.primary?.light);
    setSecondaryColor(colors?.secondary?.main);
    setActiveOrganization(orgSelected);
  }, [colors, orgSelected]);

  useEffect(() => {
    let sorted = childrenAgencies?.slice().sort((a, b) => {
      if (sort.criteria === "ASC") {
        return a[sort.item] > b[sort.item] ? 1 : -1;
      } else {
        return a[sort.item] < b[sort.item] ? 1 : -1;
      }
    });
    setSortedChildrens(sorted);
  }, [sort, childrenAgencies]);

  useEffect(() => {
    const getConcentratorSelected = async () => {
      const response = await getAgencieById(id);
      setConcentratorSelected(response);
      setChildrenAgencies(response?.childrenAgencies);
      setEditData({
        street: response?.address?.street,
        number: response?.address?.number || "0",
        zipcode: response?.address?.zipcode,
        phone: response?.phone || "0",
        status: response?.status || "-",
      });
      dispatch(setConcentratorSelectedRedux(response));
    };
    getConcentratorSelected();
  }, [id, dispatch]);

  const roles = ["OWNER", "SALESMAN"];
  let save =
    (concentratorSelected?.phone || "0") !== editData?.phone ||
    concentratorSelected?.address?.street !== editData?.street ||
    concentratorSelected?.address?.zipcode !== editData?.zipcode ||
    (concentratorSelected?.address?.number || "0") !== editData?.number;
  let errors =
    editData?.phone === "" ||
    editData?.street === "" ||
    editData?.number === "" ||
    editData.zipcode === "";
  const navigate = useNavigate();

  // const handleSetStatus = async () => {
  //   let agencieToChangeStatus = {...concentratorSelected}
  //   agencieToChangeStatus.status = agencieToChangeStatus.status === "DISABLED" ? "ENABLED" : "DISABLED"
  //   agencieToChangeStatus = {...agencieToChangeStatus, address: {...agencieToChangeStatus.address, location: null}}
  //   const response = await editAgencieData(agencieToChangeStatus)
  //   if(response.status === 200){
  //     setConcentratorSelected(agencieToChangeStatus)
  //     const concentratorsToSet = [...allConcentrators]
  //     concentratorsToSet[indexOfAgencie] = agencieToChangeStatus
  //     dispatch(organizationAgenciesUpdateAfterEdit(concentratorsToSet))
  //     Swal.fire({
  //       icon: "success",
  //       title: "Usuario modificado con éxito."
  //     })
  //   }else{
  //     Swal.fire({
  //       icon: "error",
  //       title: "Ocurrio un error, vuelve a intentarlo"
  //     })
  //   }
  // }

  // const handleEditData = (e) => {
  //   setEditData({
  //       ...editData,
  //       [e.target.name]: e.target.value
  //   })
  // }

  // const handleClose = () => {
  //   setOpenModal(false);
  //   setUserToAdd(null);
  //   setRol("");
  // };

  // const handleSelect = (item) => {
  //   setUserToAdd(item);
  // }

  // const handleAddUser = async () => {
  //   if(!rol){
  //     return
  //   }else if(concentratorSelected.relationships.some(relation => relation.person.surname.toLowerCase() === userToAdd.lastname.toLowerCase() && relation.person.name.toLowerCase() === userToAdd.firstname.toLowerCase())){
  //     setRol("")
  //     setUserToAdd(null)
  //     setOpenModal(false)
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Lo sentimos',
  //       text: 'No ha sido posible agregar al usuario debido a que el mismo ya forma parte de la concentradora',
  //     })
  //   }else{
  //     let newRelationToAdd = {
  //       person: {
  //         name: userToAdd?.firstname,
  //         surname: userToAdd?.lastname,
  //         mail: userToAdd?.email,
  //         phone: "",
  //         organization: {
  //           id: activeOrganization?.id,
  //           name: activeOrganization?.name
  //         },
  //       },
  //       relationshipKind: rol
  //     };
  //     const response = await addRelationship(concentratorSelected?.id, newRelationToAdd);
  //     if(response?.status === 200){
  //       let relationShipAdded = await response?.json();
  //       let concentratorUpdated = {
  //         ...concentratorSelected,
  //         address: {...concentratorSelected.address, location: null},
  //         relationships: [
  //           ...concentratorSelected?.relationships,
  //           {...relationShipAdded}
  //         ]
  //       }
  //       setConcentratorSelected(concentratorUpdated);
  //       if(indexOfAgencie !== -1){
  //         const concentratorsToSet = [...allConcentrators]
  //         concentratorsToSet[indexOfAgencie] = concentratorUpdated
  //         dispatch(organizationAgenciesUpdateAfterEdit(concentratorsToSet));
  //       }
  //       setUserToAdd(null)
  //       setOpenModal(false);
  //       setRol("")
  //       Swal.fire({
  //         icon: "success",
  //         title: "Usuario agregado con éxito"
  //       })
  //     }else{
  //       setOpenModal(false);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Ocurrio un error, vuelve a intentarlo"
  //       })
  //     }
  //   }
  // }

  // const handleDelete = async (relationId) => {
  //   let userToDestroy = concentratorSelected?.relationships?.find(relation => relation.id === relationId);
  //   if((concentratorSelected.relationships?.filter(relation => relation.relationshipKind === "OWNER")).length <= 1 && userToDestroy.relationshipKind === "OWNER"){
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Lo sentimos',
  //       text: 'No ha sido posible eliminar al usuario debido a que la concentradora no puede no poseer un owner',
  //     })
  //   }else{
  //     const response = await deleteRelationShip(concentratorSelected?.id, relationId);
  //     if(response?.status === 200){
  //       let concentratorUpdated = {
  //         ...concentratorSelected,
  //         address: {...concentratorSelected.address, location: null},
  //         relationships: concentratorSelected?.relationships?.filter(relation => relation.id !== relationId * 1)
  //       }
  //       setConcentratorSelected(concentratorUpdated);
  //       if(indexOfAgencie !== -1){
  //         let allConcentratorsWithoutOne = allConcentrators.filter(concentrator => concentrator.id !== id * 1)
  //         let allConcentratorsToSet = [...allConcentratorsWithoutOne]
  //         allConcentratorsToSet[indexOfAgencie] = concentratorUpdated
  //         dispatch(organizationAgenciesUpdateAfterEdit(allConcentratorsToSet));
  //       }
  //       Swal.fire({
  //         icon: 'success',
  //         title: 'Usuario eliminado',
  //         text: 'El usuario ha sigo eliminado con éxito',
  //       })
  //     }
  //   }
  // }

  // const handleSaveData = async () => {
  //   if(save || !errors){
  //     let concentratorEdited = {
  //       ...concentratorSelected,
  //       address: {
  //         ...concentratorSelected?.address,
  //         street: editData?.street,
  //         zipcode: editData?.zipcode,
  //         number: editData?.number,
  //         location: null
  //       },
  //       phone: editData?.phone
  //     }
  //     const response = await editAgencieData(concentratorEdited)
  //     if(response.status === 200){
  //       setConcentratorSelected(concentratorEdited)
  //       if(indexOfAgencie !== -1){
  //         const concentratorsToSet = [...allConcentrators]
  //         concentratorsToSet[indexOfAgencie] = concentratorEdited
  //         dispatch(organizationAgenciesUpdateAfterEdit(concentratorsToSet))
  //       }
  //       Swal.fire({
  //         icon: "success",
  //         title: "Datos guardados con éxito"
  //       })
  //     }else{
  //       Swal.fire({
  //         icon: "error",
  //         title: "Ocurrio un error, intentelo nuevamente"
  //       })
  //     }
  //   }
  // }

  return (
    <div className={styles.container}>
      <HandleRequests error={backError} loading={!concentratorSelected}>
        <div className={styles.header}>
          <div className={styles.navigator}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon
                color={"primary"}
                sx={{
                  fontSize: "2rem",
                  cursor: "pointer",
                }}
              />
            </IconButton>
          </div>
          <div className={styles.title}>
            <span>{`${concentratorSelected?.number}-${concentratorSelected?.subNumber || "0"} ${concentratorSelected?.name}`}</span>
            <p style={{ backgroundColor: primaryColor, color: textColor }}>
              {t(`concentrator`)}
            </p>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <TableContainer className={styles.table}>
            <Table>
              <TableHead className={styles.tableHead}>
                <TableRow sx={{ backgroundColor: primaryColor }}>
                  {Columns?.selecterConcentratorColumns?.map((column, i) => {
                    return (
                      <React.Fragment key={i}>
                        {createRow(column.label, "left", false, {
                          color: textColor,
                          fontSize: "0.9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        })}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:hover": { backgroundColor: "secondary.light" } }}
                >
                  <TableCell>{editData?.phone || "-"}</TableCell>
                  <TableCell>{editData?.street || "-"}</TableCell>
                  <TableCell>{editData?.number || "-"}</TableCell>
                  <TableCell>{editData?.zipcode || "-"}</TableCell>
                  <TableCell>
                    {editData?.status === "ENABLED"
                      ? t("enabled")
                      : t("disabled")}
                  </TableCell>
                  {/*{createEditRow(editData?.phone, "phone" , false, false ,editData, conditionalEditData)}*/}
                  {/*{createEditRow(editData?.street, "street", false,false , editData, conditionalEditData)}*/}
                  {/*{createEditRow(editData?.number, "number", false, false ,editData, conditionalEditData)}*/}
                  {/*{createEditRow(editData?.zipcode, "zipcode", false, false ,editData, conditionalEditData)}*/}
                  {/*{createRow(null, null, false)}*/}
                  {/* {createRow(<label onClick={() => handleSetStatus()}>
                  <Switch checked={concentratorSelected?.status === "DISABLED" ? false : true} sx={{transform: "scale(1.3)", marginLeft: 1.4}}/> 
                  </label>, null, false)} 
                  {createRow(
                    <Modal icon={<AddCircleOutlineIcon sx={{fontSize: 40, cursor: "pointer", color: primaryColor}}/>}
                      open={openModal}
                      onOpen={() => setOpenModal(true)}
                      onClose={handleClose}
                      title={"Usuario para agregar"}
                      keys={{ keys: ["firstname" , "lastname", "email"] }}
                      primaryColor={ligthPrimaryColor}
                      result={"email"}
                      format={formatResultUsers}
                      onSelect={handleSelect}
                      sxStyles={{marginLeft: 3}}
                      component={"users"}
                      text={<div className={styles.modalDiv}>
                      {
                        userToAdd ? (
                          <div className={styles.addUserContainer}>
                            <FormControl sx={{width: "100%"}} error={!rol ? true : false}>
                                <InputLabel id="demo-simple-select-label">Puesto</InputLabel>
                                <Select
                                  labelId={!rol ? "demo-simple-select-error-label" : "demo-simple-select-label"}
                                  id={!rol ? "demo-simple-select-error" : "demo-simple-select"}
                                  value={rol}
                                  label="Puesto"
                                  onChange={(e) => setRol(e.target.value)}
                                >
                                {
                                  roles.map((r, i) => <MenuItem key={i} value={r}>{r}</MenuItem>)
                                }
                                </Select>
                                {
                                  !rol ? <FormHelperText>Seleccione un puesto</FormHelperText> : null
                                }
                            </FormControl>
                              <span className={styles.nameAddUser}>{userToAdd.firstname} {userToAdd.lastname}</span>
                              <span className={styles.emailAddUser}>{userToAdd.email}</span>
                              <Tooltip title={!rol ? "Seleccione un puesto" : null}>
                                <Button variant="contained" sx={{marginTop: 2, backgroundColor: secondaryColor, color: "white", ":hover": `backgroundColor: ${primaryColor.main}`}} onClick={handleAddUser}>Agregar</Button>
                              </Tooltip>
                          </div>
                        ) : (
                          <h1>Seleccione un usuario para agregar</h1>
                        )
                      }
                    </div>}
                  />, null, false)}
                  {createRow(<EditIcon sx={{fontSize: 35, cursor: "pointer", color: primaryColor, 
                    marginLeft: 3}} onClick={() => {
                      if(!save && !errors){
                        setConditionalEditData((b) => !b)
                      }else{
                        Swal.fire({
                          icon: "error",
                          text: "Porfavor guarde los cambios."
                        })
                      }
                    } */}
                  {/* }/>
                  , null, false)} */}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{
              fontSize: "1.5rem",
              marginTop: 1,
              padding: 2,
              color: secondaryColor,
              width: "100%",
              fontWeight: 500,
            }}
          >
            {sortedChildrens?.length ? "Sub. Agencias:" : "Sin Sub. Agencias"}
          </Typography>
          <TableContainer className={styles.table}>
            <Table>
              <TableHead>
                {sortedChildrens?.length ? (
                  <TableRow sx={{ backgroundColor: primaryColor }}>
                    {/*const subAgenciesColumns = [*/}
                    {/*{ id: "number", label: t("number"), align: "center" },*/}
                    {/*{ id: "name", label: t("name"), align: "center" },*/}
                    {/*{ id: "agencyKind", label: t("type"), align: "center" },*/}
                    {/*{},*/}
                    {/*{ id: "status", label: t("state"), align: "center" },*/}
                    {/*{},*/}
                    {/*{ id: "agencyLevel", label: t("level"), align: "center"},*/}

                    {/*];*/}
                    {createRow(
                      `${t("number")} ${sort?.item === "subNumber" ? (sort?.criteria === "ASC" ? "▼" : "▲") : ""}`,
                      "left",
                      false,
                      {
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                        cursor: "pointer",
                      },
                      () => {
                        handleChangeSort("subNumber");
                      },
                    )}
                    {createRow(
                      `${t("name")} ${sort?.item === "name" ? (sort?.criteria === "ASC" ? "▼" : "▲") : ""}`,
                      "left",
                      false,
                      {
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                        cursor: "pointer",
                      },
                      () => {
                        handleChangeSort("name");
                      },
                    )}
                    {createRow(`${t("type")}`, "left", false, {
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    })}
                    {createRow(`${t("state")}`, "left", false, {
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    })}
                    {createRow(`${t("level")}`, "left", false, {
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    })}
                  </TableRow>
                ) : (
                  <></>
                )}
              </TableHead>
              <TableBody>
                {sortedChildrens?.length ? (
                  sortedChildrens?.map((SubAgencies, i) => {
                    return (
                      <React.Fragment key={i}>
                        <TableRow
                          sx={{
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                          tabIndex={-1}
                          onClick={() =>
                            navigate(
                              `../sale_point/${SubAgencies.name.replaceAll(" ", "-")}/${SubAgencies.number}-${SubAgencies.subNumber || 0}/${SubAgencies.id}`,
                            )
                          }
                        >
                          {createRow(
                            SubAgencies.number !== null &&
                              `${SubAgencies.number}-${SubAgencies.subNumber}`,
                            null,
                            i % 2,
                          )}
                          {createRow(SubAgencies.name, null, i % 2)}
                          {createRow(SubAgencies.agencyKind.name, null, i % 2)}
                          {createRow(
                            SubAgencies.status === "DISABLED"
                              ? t("disabled")
                              : t("enabled"),
                            null,
                            i % 2,
                          )}
                          {createRow(
                            SubAgencies.agencyLevel === "SALE_POINT"
                              ? t("salePoint")
                              : "-",
                            null,
                            i % 2,
                          )}
                        </TableRow>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{
              fontSize: "1.5rem",
              marginTop: 1,
              padding: 2,
              color: secondaryColor,
              width: "100%",
              fontWeight: 500,
            }}
          >
            {concentratorSelected?.relationships?.length
              ? "Relaciones:"
              : "Sin relaciones"}
          </Typography>
          <TableContainer className={styles.table}>
            <Table>
              <TableHead>
                {concentratorSelected?.relationships?.length ? (
                  <TableRow sx={{ backgroundColor: primaryColor }}>
                    {Columns?.relationsShipsColumns?.map((subAgencie, i) => {
                      return (
                        <React.Fragment key={i}>
                          {createRow(subAgencie.label, "left", false, {
                            color: textColor,
                            fontSize: ".9rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          })}
                        </React.Fragment>
                      );
                    })}
                  </TableRow>
                ) : (
                  <></>
                )}
              </TableHead>
              <TableBody>
                {concentratorSelected?.relationships?.length ? (
                  [...concentratorSelected?.relationships]
                    .sort(sortArrayFirstOwners)
                    .map((employes, i) => {
                      return (
                        <React.Fragment key={i}>
                          {
                            <TableRow tabIndex={-1}>
                              {createRow(
                                `${employes?.person?.name?.toUpperCase() || ""} ${employes?.person?.surname?.toUpperCase()}`,
                                null,
                                i % 2,
                              )}
                              {createRow(
                                employes.person.mail || "No ingresado",
                                null,
                                i % 2,
                              )}
                              {createRow(
                                employes.person.phone || "No ingresado",
                                null,
                                i % 2,
                              )}
                              {createRow(
                                employes.relationshipKind,
                                null,
                                i % 2,
                              )}
                              {/* {createRow(<IconButton sx={{fontSize: 40, marginLeft: "35%"}} onClick={() => handleDelete(employes.id)}>
                      <DeleteOutlineOutlinedIcon sx={{fontSize: 40, color: primaryColor}}/>
                      </IconButton>, null, i % 2)} */}
                            </TableRow>
                          }
                        </React.Fragment>
                      );
                    })
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <div className={styles.end}>
          {
            !conditionalEditData ? <Button
            variant="contained"
            onClick={handleSaveData}
            sx={{ width: "50%", height: "30%", backgroundColor: secondaryColor, color: textColor}}
            disabled={!save || errors}
          >
            Guardar cambios
          </Button> : <></>
        }
          </div> */}
        </div>
      </HandleRequests>
    </div>
  );
};

export default ConcentratorSelected;
